// extracted by mini-css-extract-plugin
export default {"spinner":"SpinnerLoader__spinner--PrylR"};